var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportExp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9854 8V2C14.9854 1.44772 14.5376 1 13.9854 1H5.89957C5.63435 1 5.37999 1.10536 5.19246 1.29289L1.27824 5.20711C1.09071 5.39464 0.985352 5.649 0.985352 5.91421V18C0.985352 18.5523 1.43307 19 1.98535 19H13.9854C14.5376 19 14.9854 18.5523 14.9854 18V16M5.98535 1V5C5.98535 5.55228 5.53764 6 4.98535 6H0.985352M5.98535 12H14.9854M14.9854 12L12.9854 10M14.9854 12L12.9854 14",
    stroke: "#111827",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportExp);
export default __webpack_public_path__ + "static/media/importExp.cbfae71bd0210b742615f7a3f87db5df.svg";
export { ForwardRef as ReactComponent };